// extracted by mini-css-extract-plugin
export default {"main":"Main_main__ItfJz","form":"Main_form__BHDS+","logo":"Main_logo__V6RqQ","legend":"Main_legend__8LLBr"};